import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiInputModule } from '@radioking/ui/input';

import { TrackInputWithSuggestionsComponent } from './track-input-with-suggestions.component';

@NgModule({
  imports: [CommonModule, UiInputModule],
  declarations: [TrackInputWithSuggestionsComponent],
  exports: [TrackInputWithSuggestionsComponent],
})
export class UiTrackInputWithSuggestionsModule {}
